$(() => {
  $('#shop_shop_images')
    .on('change', () => {
      $('#shop_image_upload').trigger('submit');
    });
});
